import { render } from "./LiveChat.vue?vue&type=template&id=6641bec9"
import script from "./LiveChat.vue?vue&type=script&lang=js"
export * from "./LiveChat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__